/*
  Two storefront corrections.

  1. Frequency control.
     Every package carries its own selling plan now, so the theme's frequency
     dropdown lists one entry per plan - three lines that all read the same
     thing. There is nothing to choose. The <select> is taken out of the page
     entirely (hidden, not removed, so the theme's own script can still read it)
     and a plain text span is printed in its place. The wording still comes from
     the plan, so changing the interval in Payeo changes what is printed here.

  2. Renewal disclosure.
     Neither the cart drawer nor the PayPlus checkout page says the order
     renews. One plain sentence is printed above the checkout button whenever
     the cart holds a subscription.
*/
(function () {
  var busy = false;

  function flattenFrequency() {
    var selects = document.querySelectorAll('select[data-dlp-frequency]');
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      var chosen = select.options[select.selectedIndex] || select.options[0];
      var text = chosen ? chosen.textContent.trim() : '';
      if (!text || !select.parentElement) continue;

      var label = select.previousElementSibling;
      if (!label || label.getAttribute('data-vetora-frequency') !== '1') {
        label = document.createElement('span');
        label.setAttribute('data-vetora-frequency', '1');
        select.parentElement.insertBefore(label, select);
      }
      if (label.textContent !== text) label.textContent = text;

      if (select.getAttribute('data-vetora-hidden') !== '1') {
        select.setAttribute('data-vetora-hidden', '1');
        select.setAttribute('tabindex', '-1');
        select.setAttribute('aria-hidden', 'true');
        select.style.setProperty('display', 'none', 'important');
      }
    }
  }

  function apply(root, label) {
    if (!root) return;
    var button = root.querySelector('[name="checkout"]');
    if (!button || !button.parentElement) return;
    var note = root.querySelector('[data-vetora-sub-note]');

    if (!label) {
      if (note && note.parentElement) note.parentElement.removeChild(note);
      return;
    }

    var text = 'מנוי — מתחדש אוטומטית ' + label +
      '. אפשר לדלג על משלוח, לשנות תדירות או לבטל בכל עת.';

    if (!note) {
      note = document.createElement('p');
      note.setAttribute('data-vetora-sub-note', '1');
      note.style.cssText = 'font-size:1.2rem;line-height:1.5;margin:0 0 1rem;text-align:center;';
      button.parentElement.insertBefore(note, button);
    }
    if (note.textContent !== text) note.textContent = text;
  }

  function run() {
    flattenFrequency();
    if (busy) return;
    if (!document.querySelector('[name="checkout"]')) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        var label = '';
        if (cart && cart.items) {
          for (var i = 0; i < cart.items.length; i++) {
            var allocation = cart.items[i].selling_plan_allocation;
            if (allocation && allocation.selling_plan && allocation.selling_plan.name) {
              label = allocation.selling_plan.name;
              break;
            }
          }
        }
        apply(document.querySelector('cart-drawer'), label);
        apply(document.querySelector('#main-cart-footer') || document.querySelector('.cart__footer'), label);
        busy = false;
      })
      .catch(function () { busy = false; });
  }

  flattenFrequency();
  run();
  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('click', function () { setTimeout(run, 800); }, true);

  if (window.MutationObserver) {
    new MutationObserver(flattenFrequency)
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  var ticks = 0;
  var timer = setInterval(function () {
    flattenFrequency();
    if (++ticks > 40) clearInterval(timer);
  }, 250);
})();
